import * as types from "./types";
import * as selectors from "./selectors";
import history from "./history";
import { parseQueryString, isRelativeURL } from "./utils";
import { actions as storageActions } from "../storage";

export const updateLocation = (action, location) => ({
  type: types.UPDATE_HISTORY,
  data: {
    action,
    location
  }
});

const persistentParams = ["brand", "native", "platform", "locale"];

export const buildUrl = (state, destination, params = {}) => {
  if (!isRelativeURL(destination)) {
    return destination;
  }
  const route = selectors.getCurrentRoute(state);
  const currentParams = selectors.getQueryParams(state);
  const destinationParams = parseQueryString(destination);
  const queryParams = { ...currentParams, ...params, ...destinationParams };
  const paramString = Object.keys(currentParams)
    .filter(key => persistentParams.indexOf(key) !== -1)
    .concat(Object.keys(params))
    .filter((key, index, self) => self.indexOf(key) === index)
    .concat(Object.keys(destinationParams))
    .filter((key, index, self) => self.indexOf(key) === index)
    .map(key => `${key}=${queryParams[key]}`)
    .join("&");

  const url = route.pathname + "#/" + destination.split("?")[0];
  const queryString = paramString.length > 0 ? `?${paramString}` : "";

  return url.replace(/#[/#]+/g, "#/").replace(/\/\/+/g, "/") + queryString;
};

export const go = (destination, params = {}) => (dispatch, getState) => {
  const state = getState();
  const url = buildUrl(state, destination, params);
  window.location.assign(url);
};

export const push = (destination, params = {}) => (dispatch, getState) => {
  const state = getState();
  const url = buildUrl(state, destination, params);
  history.push(url);
  //window.location = route.pathname + "#/" + destination + route.search;
};

export const replaceRoute = (destination, params = {}) => (
  dispatch,
  getState
) => {
  const state = getState();
  const url = buildUrl(state, destination, params);
  // history.replace when redirecting from an invalid url,
  // so browser's "back" button works properly for end user.
  history.replace(url);
};

export const setStoredRedirect = value =>
  storageActions.setKey("storedRedirect", value, {
    userScope: false,
    transient: true
  });
export const clearStoredRedirect = () =>
  storageActions.deleteKey("storedRedirect", { userScope: false });
